/**
 * @generated SignedSource<<fd20f37c404a6bd41896b2fec73e748d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduleSwitcher_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetScheduleSwitcherOptionsFragment_session">;
  readonly " $fragmentType": "ScheduleSwitcher_session";
};
export type ScheduleSwitcher_session$key = {
  readonly " $data"?: ScheduleSwitcher_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleSwitcher_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetScheduleSwitcherOptionsFragment_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "2b452806c2800277ebdfb4065e7a6f52";

export default node;
